import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "admin-lte/dist/css/adminlte.min.css";
import "admin-lte/dist/js/adminlte.min.js";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "leaflet/dist/leaflet.css";
import "./styles/global.css";

import { FontAwesomeIcon } from "./libraries/fontawesome.js";

const app = createApp(App);
app.component("font-awesome-icon", FontAwesomeIcon);
app.use(store).use(router).mount("#app");
